import { useQuery } from 'react-query';
import { Field } from '../types/types';
import LandscanService from './landscanService';
import { useStore } from '../providers/AppProvider';
import { Definition } from '../../../data/Definition';

export const useGetAllFields = () => {
  const { state } = useStore();

  const definition = state.definitions.find((d: Definition) =>
    d.name.toLowerCase().includes('plant')
  );
  const definitionField = state.definitions.find((d: Definition) =>
    d.name.toLowerCase().includes('field')
  );

  return useQuery<Field[]>(
    ['all-fields', definition?.id, definitionField?.id],
    () => {
      if (!definition || !definitionField) return Promise.resolve([]);
      return LandscanService.allFields(definition, definitionField);
    },
    { enabled: !!definition && !!definitionField }
  );
};
